<template>
  <div class="base">
    <m-header></m-header>
    <slot></slot>
    <m-footer></m-footer>
  </div>
</template>
  
  
<script>
import MHeader from '@/components/layouts/MHeader.vue'
import MFooter from '@/components/layouts/MFooter.vue'
import MContactUs from '@/components/landings/MContactUs'

export default {
  components: {
    MHeader,
    MFooter,
    MContactUs
  }
}
</script>
  
  
<style scoped lang="scss"></style>
  


// WEBPACK FOOTER //
// src/components/layouts/MBase.vue